"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

function isDateValid(date, format) {
  return moment_1.default(date, format).isValid();
}

exports.isDateValid = isDateValid;